import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-input-date-time-range" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "n-input-date-time-range__divider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NDateIntervalSelect = _resolveComponent("NDateIntervalSelect")!
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), _mergeProps({
      modelValue: _ctx.from ? _ctx.from.toDate() : '',
      min: _ctx.min,
      max: _ctx.maxDate,
      "time-enabled": _ctx.timeEnabled,
      "seconds-enabled": _ctx.secondsEnabled,
      "date-format": _ctx.dateFormat,
      autofocus: _ctx.autofocus,
      accesskey: _ctx.accesskey,
      disabled: _ctx.disabled,
      clearable: _ctx.clearable,
      plain: _ctx.plain,
      "data-qa": `${_ctx.dataQa}.from`
    }, _ctx.placeholders[0], { "onUpdate:modelValue": _ctx.fromChangeHandler }), null, 16, ["modelValue", "min", "max", "time-enabled", "seconds-enabled", "date-format", "autofocus", "accesskey", "disabled", "clearable", "plain", "data-qa", "onUpdate:modelValue"])),
    _hoisted_2,
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), _mergeProps({
      modelValue: _ctx.to ? _ctx.to.toDate() : '',
      min: _ctx.minDate,
      max: _ctx.max,
      "time-enabled": _ctx.timeEnabled,
      "seconds-enabled": _ctx.secondsEnabled,
      "date-format": _ctx.dateFormat,
      disabled: _ctx.disabled,
      clearable: _ctx.clearable,
      plain: _ctx.plain,
      "data-qa": `${_ctx.dataQa}.to`
    }, _ctx.placeholders[1], { "onUpdate:modelValue": _ctx.toChangeHandler }), null, 16, ["modelValue", "min", "max", "time-enabled", "seconds-enabled", "date-format", "disabled", "clearable", "plain", "data-qa", "onUpdate:modelValue"])),
    (_ctx.intervals.length)
      ? (_openBlock(), _createBlock(_component_NDateIntervalSelect, {
          key: 0,
          intervals: _ctx.intervals,
          "onUpdate:modelValue": _ctx.intervalSelectHandler
        }, null, 8, ["intervals", "onUpdate:modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.clearable && _ctx.clearButton && (_ctx.to || _ctx.from))
      ? (_openBlock(), _createBlock(_component_NButton, {
          key: 1,
          class: "n-input-date-time-range__clear",
          icon: "close",
          type: "link",
          onAction: _ctx.reset
        }, null, 8, ["onAction"]))
      : _createCommentVNode("", true)
  ]))
}